import React from "react";
import ProcessedImage from "../common/ProcessedImage/ProcessedImage";
import * as styles from "./MediaContentItem.module.scss";
export interface MediaContentItemProps {
	title: string;
	text: string;
	imgSrc: string;
	imgAlt: string;
}
export const MediaContentItem: React.FC<MediaContentItemProps> = ({
	title,
	text,
	imgSrc,
	imgAlt,
}) => {
	return (
		<div className={styles.mediacontentitem}>
			<div className={styles.first}>
				<ProcessedImage
					src={imgSrc}
					alt={imgAlt}
					dimensions="200x200"
					width={200}
					height={200}
					loading={"lazy"}
				/>
			</div>
			<div className={styles.second}>
				<h3>{title}</h3>

				<div
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{ __html: text }}
				/>
			</div>
		</div>
	);
};

export default MediaContentItem;
